import { render } from "./header-actions.vue?vue&type=template&id=381235ba"
import script from "./header-actions.vue?vue&type=script&setup=true&lang=js"
export * from "./header-actions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/settings/pages/roles/components/header-actions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "381235ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('381235ba', __exports__)) {
    console.log('reload')
    api.reload('381235ba', __exports__)
  }
  
  module.hot.accept("./header-actions.vue?vue&type=template&id=381235ba", () => {
    console.log('re-render')
    api.rerender('381235ba', render)
  })

}


export default __exports__